export default __webpack_public_path__ + "static/media/ai-based-app.0c083a13.png";